module.exports = {
    nav:{
        language: "ENGLISH",
        search:'Search TIANXIN'
    },
    readmore:'Read More',
    showed:'Show ',
    product:'',
    all:'Total ',
    loadmore:'Load More'
 }